export default __webpack_public_path__ + "static/media/Adventure1.581e02ad.png";